import React from 'react';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import useCustomTranslation from '../../hooks/useCustomTranslation';

const wizardStandardHeader = (props) => {

  const { device } = useWindowDimensions();
  const ct = useCustomTranslation();

  return (

    <div className="row justify-content-center">
      <div className="col-lg-11 col-xl-11">
        {(device !== 'mobile')? <div className="page-header"><h1>{ ct('wizard.standard_header') }</h1></div> : null}
        {props.children}
      </div>
    </div>
  )

};

export default wizardStandardHeader;



// WEBPACK FOOTER //
// ./src/components/Wizard/WizardStandardHeader.js